<template>
  <div
    class="py-4 container-fluid min-vh-100"
    :class="$store.state.isDarkMode ? 'howto-page-dark' : 'bg-light-moniex'"
    :style="$store.state.isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'background: #f8f9fa; min-height: 100vh;'"
  >
    <div
      class="howto-hero-banner mb-3"
      :style="$store.state.isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="howto-hero-content">
        <h1
          :style="$store.state.isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Animátor</h1>
        <p :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">
          Podmínky a pravidla pro animátory — co platí, než začneš hrát s ostatními.
        </p>
      </div>
    </div>

    <div v-if="AnimatorConditionData && AnimatorConditionData.length">
      <div class="row mb-4" v-if="AnimatorConditionData[0]">
        <div class="col-12">
          <div
            class="border-0 shadow-sm rounded-4 overflow-hidden p-4 moniex-howto-card"
            :style="surfaceStyle"
          >
            <div class="d-flex align-items-start">
              <div class="avatar-circle me-3 fw-bold bg-orange-soft text-orange">
                {{ initials(AnimatorConditionData[0].AnimatorConditionTitle) }}
              </div>
              <div class="w-100">
                <h5
                  class="mb-0 fw-bold fs-5"
                  :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                >
                  {{ AnimatorConditionData[0].AnimatorConditionTitle }}
                </h5>
                <div
                  class="fs-6 mt-3 v-html-content line-height-lg"
                  :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important;' : ''"
                  v-html="AnimatorConditionData[0].AnimatorConditionText"
                ></div>
                <button
                  v-if="AnimatorConditionData[0].AnimatorConditionButton && AnimatorConditionData[0].AnimatorConditionButtonText"
                  type="button"
                  class="btn rounded-pill px-4 fw-bold mt-3 howto-cta"
                  :class="$store.state.isDarkMode ? 'howto-cta-dark' : 'btn-primary'"
                  @click="clickHandler(AnimatorConditionData[0])"
                >
                  {{ AnimatorConditionData[0].AnimatorConditionButtonText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row align-items-start">
        <div class="col-12 col-lg-8">
          <div
            v-for="(data, index) in AnimatorConditionData.slice(1)"
            :key="data.AnimatorConditionTitle + '-' + index"
            class="border-0 shadow-sm rounded-4 overflow-hidden mb-4 p-4 moniex-howto-card"
            :style="surfaceStyle"
          >
            <div class="d-flex align-items-start">
              <div
                class="avatar-circle me-3 fw-bold"
                :class="circleClass(index)"
              >
                {{ initials(data.AnimatorConditionTitle) }}
              </div>
              <div class="w-100">
                <h5
                  class="mb-0 fw-bold fs-5"
                  :style="$store.state.isDarkMode ? 'color: #E2E8F0 !important;' : 'color: #212529;'"
                >
                  {{ data.AnimatorConditionTitle }}
                </h5>
                <div
                  class="fs-6 mt-3 v-html-content line-height-lg"
                  :style="$store.state.isDarkMode ? 'color: #CBD5E1 !important;' : ''"
                  v-html="data.AnimatorConditionText"
                ></div>
                <button
                  v-if="data.AnimatorConditionButton && data.AnimatorConditionButtonText"
                  type="button"
                  class="btn rounded-pill px-4 fw-bold mt-3 howto-cta"
                  :class="$store.state.isDarkMode ? 'howto-cta-dark' : 'btn-primary'"
                  @click="clickHandler(data)"
                >
                  {{ data.AnimatorConditionButtonText }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-4 mt-4 mt-lg-0">
          <div
            class="border-0 shadow-sm rounded-4 text-center position-relative mb-4 img-inga-card"
            :class="$store.state.isDarkMode ? 'p-0' : 'p-3'"
            :style="$store.state.isDarkMode
              ? 'background: #0F172A !important; border: none !important; box-shadow: none !important; border-radius: 0.65rem !important;'
              : 'background: #ffffff !important; border: none !important; border-radius: 0.65rem !important;'"
          >
            <div
              class="inga-speech-bubble"
              :class="{ 'inga-speech-bubble-dark': $store.state.isDarkMode }"
            >
              „Animátor není extra život. Je to extra zodpovědnost — a tyhle podmínky platí celé.“
            </div>
            <IngaPortrait :src="imgRoot + 'inga.jpg'" />
          </div>

          <ActiveGamesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import dataService from "@/services/dataService.js";
import ActiveGamesSidebar from "./components/custom/ActiveGamesSidebar.vue";
import IngaPortrait from "./components/custom/IngaPortrait.vue";

const store = useStore();
const router = useRouter();
const AnimatorConditionData = ref([]);
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);

const surfaceStyle = computed(() => {
  if (store.state.isDarkMode) {
    return "background: #0F172A !important; background-color: #0F172A !important; background-image: none !important; border: 1px solid #334155 !important; --bs-card-bg: #0F172A; border-radius: 0.65rem !important;";
  }
  return "background: #ffffff; border: 1px solid transparent; border-radius: 0.65rem !important;";
});

const colors = ["success", "primary", "warning", "info", "orange"];

const circleClass = (index) => {
  const c = colors[index % colors.length];
  return `bg-${c}-soft text-${c}`;
};

const initials = (title) => {
  const words = String(title || "")
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};

const fetchAnimatorConditionData = async () => {
  const data = await dataService.GetAnimatorCondition();
  AnimatorConditionData.value = Array.isArray(data) ? data : data ? Object.values(data) : [];
};

const clickHandler = (data) => {
  if (data.AnimatorConditionButton === "ACTUAL_GAME") {
    router.push({ path: "/" });
  } else if (data.AnimatorConditionButton === "PROFILE") {
    router.push({ path: "/profil" });
  } else if (data.AnimatorConditionButton === "REGISTRATION") {
    store.commit("toggleRegisterForm");
  }
};

fetchAnimatorConditionData();
</script>

<style scoped>
.howto-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}

.howto-hero-content h1 {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #C2460F;
}

.howto-hero-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}

.howto-page-dark .howto-hero-banner {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
}

.bg-light-moniex { background-color: #f8f9fa; }
.moniex-howto-card {
  border-radius: 0.65rem !important;
  overflow: hidden;
}
.line-height-lg { line-height: 1.6; }

.bg-success-soft { background-color: rgba(40, 167, 69, 0.1) !important; }
.text-success { color: #28a745 !important; }
.bg-warning-soft { background-color: rgba(255, 193, 7, 0.1) !important; }
.text-warning { color: #ffc107 !important; }
.bg-orange-soft { background-color: rgba(255, 138, 72, 0.12) !important; }
.text-orange { color: #FF8A48 !important; }
.bg-primary-soft { background-color: rgba(13, 110, 253, 0.1) !important; }
.text-primary { color: #0d6efd !important; }
.bg-info-soft { background-color: rgba(13, 202, 240, 0.1) !important; }
.text-info { color: #0dcaf0 !important; }

.avatar-circle {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 0.95rem !important;
  flex-shrink: 0 !important;
}

.howto-cta-dark {
  background: #FF8A4C !important;
  border: none !important;
  color: #0F172A !important;
}

.img-inga-card { margin-top: 3.5rem !important; border: none !important; border-radius: 0.65rem !important; }

.inga-speech-bubble {
  position: absolute !important;
  top: -65px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background-color: #ffffff !important;
  border: 2px solid #FF7A00 !important;
  color: #1E293B !important;
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  padding: 10px 14px !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06) !important;
  z-index: 10 !important;
  width: 92% !important;
  max-width: 280px !important;
}
.inga-speech-bubble-dark {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
}
.inga-speech-bubble::after, .inga-speech-bubble::before {
  content: ''; position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); border-style: solid; display: block; width: 0;
}
.inga-speech-bubble::after { border-width: 10px 10px 0; border-color: #ffffff transparent transparent; z-index: 11; }
.inga-speech-bubble::before { bottom: -13px; border-width: 11px 11px 0; border-color: #FF7A00 transparent transparent; z-index: 9; }
.inga-speech-bubble-dark::after { border-color: #1E293B transparent transparent; }

.v-html-content :deep(div),
.v-html-content :deep(p),
.v-html-content :deep(span),
.v-html-content :deep(li) {
  background: transparent !important;
  background-color: transparent !important;
  color: inherit !important;
}
</style>
